import {
  border,
  heading,
  pricingButton,
  pricingContent,
  wrapper,
} from "@/components/mhealth-studio/pricing/styles/mhealth-pricing";
import { SectionLayout } from "layouts";
import { Trans, useTranslation } from "react-i18next";

const MhealthPricing = () => {
  const { t } = useTranslation();

  return (
    <SectionLayout
      separatorProps={{
        variant: "offset",
      }}
      className="bg-[#E4E4E4]"
      heading={<Trans i18nKey="mhealth.pricing.title">Pricing</Trans>}
    >
      <div>
        <p className={pricingContent}>{t("mhealth.pricing.description")}</p>
      </div>
      <div className={"flex mobile:justify-center tablet:justify-start"}>
        <a href={"/pricing"}>
          <button type={"button"} className={pricingButton}>
            {t("mhealth.pricing.button.title")}
            <img
              className={"pl-0.5"}
              alt={"arrow point to the right"}
              src={"/assets/images/mhealth/pricing/arrow-pointing-to-right.svg"}
            />
          </button>
        </a>
      </div>
    </SectionLayout>
  );
};

export default MhealthPricing;
